export default __webpack_public_path__ + "static/media/SunDarkIcon.2530211b.svg";